import request, { _POST } from "@/services/request";

export type ParseCuecardRequest = {
  headSupplierItemLink: string;
  fileUrl: string;
};

export type CuecardProductInfo = {
  parsed?: boolean;
  productName?: string;
  matchedProductName?: string;
  matchScore?: number;
  marketPrice?: string;
  livePrice?: string;
  totalStock?: string;
  commission?: string;
  spec?: string;
  express?: string;
  deliveryTime?: string;
  deliveryFrom?: string;
  excludedDeliveryArea?: string;
  sellingPoints?: string[];
  afterSale?: string;
  customFields?: ProductCuecardCustomField[];
};

export type ParseCuecardResponse = {
  product?: CuecardProductInfo;
  rawText?: string;
  traceId?: string;
  costMs?: number;
};

export type GetProductCuecardRequest = {
  headSupplierItemLink: string;
};

export type SaveProductCuecardRequest = {
  id?: string;
  headSupplierItemLink: string;
  fileUrl: string;
  productName: string;
  productImage: string;
  marketPrice: string | null;
  livePrice: number | null;
  totalStock: string | null;
  commission: string;
  spec: string;
  express: string;
  deliveryTime: string;
  deliveryFrom: string;
  excludedDeliveryArea: string;
  sellingPoints: string[];
  afterSale: string;
  customFields: ProductCuecardCustomField[];
};

export type ProductCuecardCustomField = {
  name?: string;
  value?: string;
  type?: "UNKNOWN" | "TEXT" | "IMAGE";
};

export type ProductCuecardInfo = {
  id?: string;
  headSupplierItemLink?: string;
  fileUrl?: string;
  productName?: string;
  productImage?: string;
  marketPrice?: string;
  livePrice?: string;
  totalStock?: string;
  commission?: string;
  spec?: string;
  express?: string;
  deliveryTime?: string;
  deliveryFrom?: string;
  excludedDeliveryArea?: string;
  sellingPoints?: string[];
  afterSale?: string;
  customFields?: ProductCuecardCustomField[];
  hasCuecardInfo?: boolean;
};

const parseProductFile = (params: ParseCuecardRequest) =>
  request<ParseCuecardResponse, ParseCuecardRequest>(_POST, "/admin/cuecard/parseProductFile", undefined, {
    timeout: 60_000,
  })(params);

const getProductCuecard = (params: GetProductCuecardRequest) =>
  request<ProductCuecardInfo, GetProductCuecardRequest>(_POST, "/admin/cuecard/get")(params);

const saveProductCuecard = (params: SaveProductCuecardRequest) =>
  request<ProductCuecardInfo, SaveProductCuecardRequest>(_POST, "/admin/cuecard/save")(params);

export default {
  parseProductFile,
  getProductCuecard,
  saveProductCuecard,
};
